import { apiRequest } from "./client";

export const settingsApi = {
  get(projectId) {
    return apiRequest(`/projects/${projectId}/settings`);
  },

  update(projectId, payload) {
    return apiRequest(`/projects/${projectId}/settings`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  createPreviewToken(projectId) {
    return apiRequest(`/projects/${projectId}/settings/preview-token`, {
      method: "POST",
    });
  },

  publish(projectId) {
    return apiRequest(`/projects/${projectId}/settings/publish`, {
      method: "POST",
    });
  },
};
